<template>
  <script type="application/ld+json">
  {{ ldJsonItems }}
  </script>
</template>

<script>
export default {
  props: ['items'],
  computed: {
    ldJsonItems() {
      const output = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [],
      };
      if (Array.isArray(this.items) && this.items.length > 0) {
        for (let i = 0; i < this.items.length; i += 1) {
          output.itemListElement.push({
            '@type': 'ListItem',
            position: i + 1,
            item: {
              '@id': this.items[i].href,
              name: this.items[i].text,
            },
          });
        }
      }
      return JSON.stringify(output);
    },
  },
};
</script>
<style scoped>
</style>